import IntegrationMessageDetailPage from '../shared/IntegrationMessageDetailPage';

const InboxMessageDetailPage = () => <IntegrationMessageDetailPage kind="inbox" />;

export default InboxMessageDetailPage;
